import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import empty from "@xo-union/constant-object";
import shortid from "shortid";
/**
 * This HOC injects unique ids into the lower order component (LOC)
 *
 * 1. It makes sure to generate the unique ids ONCE during creation of the component
 * 2. It allows ids to be passed in as props, which take precedence
 * 3. If the prop provided id changes, the change is passed down to the LOC
 */

var uniqueID = function uniqueID(propNames) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty,
      _ref$generate = _ref.generate,
      generate = _ref$generate === void 0 ? shortid.generate : _ref$generate;

  var generateKeysReducer = function generateKeysReducer(obj, key) {
    return _objectSpread(_defineProperty({}, key, generate()), obj);
  };

  return function (LowerOrderComponent) {
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      var fallbackIds = React.useRef(_reduceInstanceProperty(propNames).call(propNames, generateKeysReducer, empty));
      return /*#__PURE__*/React.createElement(LowerOrderComponent, _extends({
        ref: ref
      }, fallbackIds.current, props));
    });
  };
};

export default uniqueID;
export var useUniqueID = function useUniqueID(override) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty,
      _ref2$generate = _ref2.generate,
      generate = _ref2$generate === void 0 ? shortid.generate : _ref2$generate;

  var _React$useRef = React.useRef(typeof override !== 'undefined'),
      isControlled = _React$useRef.current;

  var idRef = React.useRef();

  if (isControlled) {
    return override;
  }

  if (!idRef.current) {
    idRef.current = generate();
  }

  return idRef.current;
};